import Grid from '@material-ui/core/Grid'
import PageSubTitle from '../Common/PageSubTitle'
import {Trans} from 'react-i18next'
import messages from '../../assets/messages'
import {usePammAgentOffers} from './usePammAgentOffers'
import {PammAgentOffer} from './components/PammAgentOffer'

export const PammAgentOffers = () => {
  const {pammAgentOffers, loading} = usePammAgentOffers()
  console.log('pammAgentOffers', pammAgentOffers)
  console.log('loading', loading)
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageSubTitle>
          <Trans {...messages.pammAgentOffers} />
        </PageSubTitle>
      </Grid>
      {pammAgentOffers.map((offer) => (
        <PammAgentOffer offer={offer} />
      ))}
    </Grid>
  )
}
